import { UrlObject } from 'url'
import * as _ from 'lodash'

import { getLocale } from './helper'

interface TinTucParams {
  url?: string
  page?: number
}

export const megastoryPage = {
  routeUrl(query: any = {}): UrlObject {
    let pathname = '/megastory'
    return {
      pathname,
      query,
    }
  },
  routeUrlAlias(query: any = {}): UrlObject {
    let pathname = '/megastory'
    let locale = getLocale()

    if (!_.isEmpty(locale)) {
      pathname = `/${locale}` + pathname
    }

    if (query.url) {
      pathname = pathname + `/${query.url}`
    } else if (query.page) {
      return {
        pathname,
        query,
      }
    }

    return {
      pathname,
    }
  },
}
